import BigHall1 from '../assetts/images/viphall1.jpg';
import BigHall2 from '../assetts/images/viphall2.jpg';
import BigHall3 from '../assetts/images/viphall3.jpg';

import VipHalls from '../assetts/halls/viphalls.jpg';
import VipHalls1 from '../assetts/halls/vipzal2.png';
import VipHalls2 from '../assetts/halls/viphalls2.jpg';
import VipHalls3 from '../assetts/halls/vipzal3.png';
import VipHalls4 from '../assetts/halls/vipzal.png';
import VipHalls5 from '../assetts/halls/viphalls5.jpg';
import VipHalls6 from '../assetts/halls/viphalls6.jpg';

import StandartHalls from '../assetts/halls/vipzal5.png';

const halls = [
  // {
  //   title: 'Стандарт Зал',
  //   images: [],
  //   type: 'Game Zone',
  //   capacity: '2 & 3',
  //   price: 'час 200 с',
  //   description:
  //     'Самый большой зал, идеально подходящий для дружеской и соревновательной атмосферы.',
  // },
  {
    title: 'Большой Зал',
    images: [BigHall2, BigHall1, BigHall3],
    type: 'Game Zone',
    capacity: 'от 4 до 12 ',
    price: 'час 400 с',
    grand: true,
    description:
      'Самый большой зал, идеально подходящий для дружеской и соревновательной атмосферы.',
  },
  {
    title: 'Vip залы',
    images: [
      VipHalls,
      VipHalls1,
      VipHalls2,
      VipHalls3,
      VipHalls4,
      VipHalls5,
      VipHalls6,
      StandartHalls,
    ],
    type: 'Game Zone',
    capacity: 'от 2 до 8',
    price: 'час 200 с',
    description:
      'Ваш личный уголок для полного погружения в игру. Наслаждайтесь комфортом и тишиной!',
  },
];

export default halls;
